import { connect } from 'react-redux'
import AssistanceList from '../../components/assistance/AssistanceList'
import { removeAssistance } from '../../state/actions/assistance'
import { filterAssistances } from '../../state/selectors'
import { IAssistanceCategoryObject, IAssistanceObject, IStoreState } from '../../types'

interface IAssistanceListPropItems {
  assistances: { [key: string]: IAssistanceObject }
  categories: { [key: string]: IAssistanceCategoryObject }
}

export function mapStateToProps(state: IStoreState, ownProps: any): IAssistanceListPropItems {
  return {
    assistances:
      state.assistanceSearch.query === ''
        ? state.assistances.items
        : filterAssistances(state, state.assistanceSearch.query),
    categories: state.assistanceCategories.items
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onRemove: (assistance: IAssistanceObject) => {
      dispatch(removeAssistance(assistance))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssistanceList)



// WEBPACK FOOTER //
// ./src/containers/assistance/AssistanceList.ts